import { BehaviorSubject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { Injectable, Component, EventEmitter, Output, Input, Optional, ViewContainerRef, ViewChild, Pipe, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@ngx-formly/core';

const _c0 = function (a0, a1) { return { active: a0, disabled: a1 }; };
function TabsetComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 3);
    ɵngcc0.ɵɵlistener("click", function TabsetComponent_li_1_Template_li_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const tab_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return !tab_r1.disabled && !tab_r1.hidden && ctx_r2.select(tab_r1); });
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(2, _c0, tab_r1.active && !tab_r1.disabled && !tab_r1.hidden, tab_r1.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", tab_r1.title, " ");
} }
const _c1 = function (a0) { return { empty: a0 }; };
const _c2 = ["*"];
function TabComponent_ng_content_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngIf", "!tabsetService || (active && !disabled && !hidden)"]);
} }
function FormlyFieldTabComponent_formly_field_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "formly-field", 2);
} if (rf & 2) {
    const f_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("field", f_r1);
} }
function FormlyFieldTabsetComponent_formly_field_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "formly-field", 2);
} if (rf & 2) {
    const f_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("field", f_r1);
} }
const _c3 = ["fieldComponent"];
function FormlyWrapperTabComponent_ng_template_1_Template(rf, ctx) { }
class TabsetService {
    constructor() {
        this._tabs = new BehaviorSubject([]);
    }
    /**
     * @return {?}
     */
    get tabs() {
        return this._tabs.value.slice();
    }
    /**
     * @return {?}
     */
    get tabs$() {
        return this._tabs.asObservable();
    }
    /**
     * @param {?} tab
     * @return {?}
     */
    add(tab) {
        this._tabs.next(this._tabs.value.filter((/**
         * @param {?} t
         * @return {?}
         */
        t => t !== tab)).concat(tab));
    }
    /**
     * @param {?} tab
     * @return {?}
     */
    remove(tab) {
        this._tabs.next(this._tabs.value.filter((/**
         * @param {?} t
         * @return {?}
         */
        t => t !== tab)));
    }
    /**
     * @return {?}
     */
    update() {
        this._tabs.next(this.tabs);
    }
}
TabsetService.ɵfac = function TabsetService_Factory(t) { return new (t || TabsetService)(); };
TabsetService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TabsetService, factory: TabsetService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabsetService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TabsetComponent {
    /**
     * @param {?} tabsetService
     */
    constructor(tabsetService) {
        this.tabsetService = tabsetService;
        this.activeTabChange = new EventEmitter();
        this._tabs = [];
        this._visibleCount = 0;
    }
    /**
     * @return {?}
     */
    get tabs() {
        return this._tabs;
    }
    /**
     * @return {?}
     */
    get visibleCount() {
        return this._visibleCount;
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        this.subscription = this.tabsetService.tabs$.subscribe((/**
         * @return {?}
         */
        () => {
            this.onTabsChanged();
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    /**
     * @param {?} tab
     * @return {?}
     */
    select(tab) {
        this.tabsetService.tabs.forEach((/**
         * @param {?} t
         * @return {?}
         */
        t => {
            t.active = t === tab;
        }));
        this.activeTabChange.emit(tab ? tab.title : null);
    }
    /**
     * @private
     * @return {?}
     */
    onTabsChanged() {
        Promise.resolve().then((/**
         * @return {?}
         */
        () => {
            if (this.subscription.closed) {
                return;
            }
            /** @type {?} */
            const tabs = this.tabsetService.tabs;
            this._tabs = tabs;
            this._visibleCount = tabs.filter((/**
             * @param {?} t
             * @return {?}
             */
            t => !t.hidden)).length;
            if (!tabs.some((/**
             * @param {?} tab
             * @return {?}
             */
            tab => tab.active && !tab.disabled && !tab.hidden))) {
                this.select(tabs.find((/**
                 * @param {?} t
                 * @return {?}
                 */
                t => !t.disabled && !t.hidden)));
            }
        }));
    }
}
TabsetComponent.ɵfac = function TabsetComponent_Factory(t) { return new (t || TabsetComponent)(ɵngcc0.ɵɵdirectiveInject(TabsetService)); };
TabsetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TabsetComponent, selectors: [["formly-tabs-tabset"]], outputs: { activeTabChange: "activeTabChange" }, ngContentSelectors: _c2, decls: 5, vars: 6, consts: [[1, "nav", "nav-tabs"], ["class", "nav-item", "role", "presentation", 3, "click", 4, "ngFor", "ngForOf"], [1, "content", 3, "ngClass"], ["role", "presentation", 1, "nav-item", 3, "click"], [1, "nav-link", 3, "ngClass"]], template: function TabsetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, TabsetComponent_li_1_Template, 3, 5, "li", 1);
        ɵngcc0.ɵɵpipe(2, "visible");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(2, 2, ctx.tabs));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c1, ctx.visibleCount === 0));
    } }, directives: function () { return [ɵngcc1.NgForOf, ɵngcc1.NgClass]; }, pipes: function () { return [VisiblePipe]; }, styles: [".nav-link[_ngcontent-%COMP%]{cursor:pointer;cursor:hand}[_nghost-%COMP%] > .content[_ngcontent-%COMP%]{border:1px solid #ddd;border-top:0;padding:1em}"] });
/** @nocollapse */
TabsetComponent.ctorParameters = () => [
    { type: TabsetService }
];
TabsetComponent.propDecorators = {
    activeTabChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabsetComponent, [{
        type: Component,
        args: [{
                selector: 'formly-tabs-tabset',
                template: "<ul class=\"nav nav-tabs\">\r\n  <li class=\"nav-item\" *ngFor=\"let tab of tabs | visible\" role=\"presentation\" (click)=\"!tab.disabled && !tab.hidden && select(tab)\">\r\n    <div class=\"nav-link\" [ngClass]=\"{active: tab.active && !tab.disabled && !tab.hidden, disabled: tab.disabled}\">\r\n      {{ tab.title }}\r\n    </div>\r\n  </li>\r\n</ul>\r\n<div class=\"content\" [ngClass]=\"{empty: visibleCount === 0}\">\r\n  <ng-content></ng-content>\r\n</div>",
                styles: [".nav-link{cursor:pointer;cursor:hand}:host>.content{border:1px solid #ddd;border-top:0;padding:1em}"]
            }]
    }], function () { return [{ type: TabsetService }]; }, { activeTabChange: [{
            type: Output
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TabComponent {
    /**
     * @param {?} tabsetService
     */
    constructor(tabsetService) {
        this.tabsetService = tabsetService;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (!changes.title) {
            this.tabsetService.update();
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.tabsetService) {
            this.tabsetService.add(this);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.tabsetService) {
            this.tabsetService.remove(this);
        }
    }
}
TabComponent.ɵfac = function TabComponent_Factory(t) { return new (t || TabComponent)(ɵngcc0.ɵɵdirectiveInject(TabsetService, 8)); };
TabComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TabComponent, selectors: [["formly-tabs-tab"]], inputs: { active: "active", disabled: "disabled", hidden: "hidden", title: "title" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2, decls: 1, vars: 1, consts: [[4, "ngIf"]], template: function TabComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TabComponent_ng_content_0_Template, 1, 0, "ng-content", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.tabsetService || ctx.active && !ctx.disabled && !ctx.hidden);
    } }, directives: [ɵngcc1.NgIf], styles: [""] });
/** @nocollapse */
TabComponent.ctorParameters = () => [
    { type: TabsetService, decorators: [{ type: Optional }] }
];
TabComponent.propDecorators = {
    active: [{ type: Input }],
    disabled: [{ type: Input }],
    hidden: [{ type: Input }],
    title: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabComponent, [{
        type: Component,
        args: [{
                selector: 'formly-tabs-tab',
                template: "<ng-content *ngIf=\"!tabsetService || (active && !disabled && !hidden)\"></ng-content>",
                styles: [""]
            }]
    }], function () { return [{ type: TabsetService, decorators: [{
                type: Optional
            }] }]; }, { active: [{
            type: Input
        }], disabled: [{
            type: Input
        }], hidden: [{
            type: Input
        }], title: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormlyFieldTabComponent extends FieldType {
    constructor() {
        super();
    }
    /**
     * @return {?}
     */
    get title() {
        return this.to.tabTitle;
    }
    /**
     * @return {?}
     */
    get disabled() {
        return this.to.tabDisabled;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set disabled(value) {
        this.to.tabDisabled = !!value;
    }
    /**
     * @return {?}
     */
    get hidden() {
        return this.to.tabHidden;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set hidden(value) {
        this.to.tabHidden = !!value;
    }
}
FormlyFieldTabComponent.ɵfac = function FormlyFieldTabComponent_Factory(t) { return new (t || FormlyFieldTabComponent)(); };
FormlyFieldTabComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormlyFieldTabComponent, selectors: [["formly-field-tab"]], hostVars: 2, hostBindings: function FormlyFieldTabComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.field.fieldGroupClassName || "");
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 4, consts: [[3, "title", "disabled", "hidden"], [3, "field", 4, "ngFor", "ngForOf"], [3, "field"]], template: function FormlyFieldTabComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "formly-tabs-tab", 0);
        ɵngcc0.ɵɵtemplate(1, FormlyFieldTabComponent_formly_field_1_Template, 1, 1, "formly-field", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("title", ctx.title)("disabled", ctx.disabled)("hidden", ctx.hidden);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.field.fieldGroup);
    } }, directives: [TabComponent, ɵngcc1.NgForOf, ɵngcc2.FormlyField], encapsulation: 2 });
/** @nocollapse */
FormlyFieldTabComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyFieldTabComponent, [{
        type: Component,
        args: [{
                selector: 'formly-field-tab',
                template: `
        <formly-tabs-tab [title]="title" [disabled]="disabled" [hidden]="hidden">
            <formly-field *ngFor="let f of field.fieldGroup" [field]="f"></formly-field>
        </formly-tabs-tab>
    `,
                host: {
                    '[class]': 'field.fieldGroupClassName || ""'
                }
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormlyFieldTabsetComponent extends FieldType {
    /**
     * @return {?}
     */
    get activeTab() {
        return this.to.activeTab;
    }
    /**
     * @param {?} tabTitle
     * @return {?}
     */
    onActiveTagChange(tabTitle) {
        this.to.activeTab = tabTitle == null ? null : tabTitle;
        if (this.to.activeTabChange) {
            this.to.activeTabChange(this.to.activeTab);
        }
    }
}
FormlyFieldTabsetComponent.ɵfac = /*@__PURE__*/ function () { let ɵFormlyFieldTabsetComponent_BaseFactory; return function FormlyFieldTabsetComponent_Factory(t) { return (ɵFormlyFieldTabsetComponent_BaseFactory || (ɵFormlyFieldTabsetComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(FormlyFieldTabsetComponent)))(t || FormlyFieldTabsetComponent); }; }();
FormlyFieldTabsetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormlyFieldTabsetComponent, selectors: [["formly-field-tabset"]], hostVars: 2, hostBindings: function FormlyFieldTabsetComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.field.fieldGroupClassName || "");
    } }, features: [ɵngcc0.ɵɵProvidersFeature([TabsetService]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [[3, "activeTabChange"], [3, "field", 4, "ngFor", "ngForOf"], [3, "field"]], template: function FormlyFieldTabsetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "formly-tabs-tabset", 0);
        ɵngcc0.ɵɵlistener("activeTabChange", function FormlyFieldTabsetComponent_Template_formly_tabs_tabset_activeTabChange_0_listener($event) { return ctx.onActiveTagChange($event); });
        ɵngcc0.ɵɵtemplate(1, FormlyFieldTabsetComponent_formly_field_1_Template, 1, 1, "formly-field", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.field.fieldGroup);
    } }, directives: [TabsetComponent, ɵngcc1.NgForOf, ɵngcc2.FormlyField], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyFieldTabsetComponent, [{
        type: Component,
        args: [{
                selector: 'formly-field-tabset',
                template: `
        <formly-tabs-tabset (activeTabChange)="onActiveTagChange($event)">
            <formly-field *ngFor="let f of field.fieldGroup" [field]="f"></formly-field>
        </formly-tabs-tabset>
    `,
                host: {
                    '[class]': 'field.fieldGroupClassName || ""'
                },
                providers: [TabsetService]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormlyWrapperTabComponent extends FieldWrapper {
    /**
     * @return {?}
     */
    get title() {
        return this.to.tabTitle;
    }
    /**
     * @return {?}
     */
    get disabled() {
        return this.to.tabDisabled;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set disabled(value) {
        this.to.tabDisabled = !!value;
    }
    /**
     * @return {?}
     */
    get hidden() {
        return this.to.tabHidden;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set hidden(value) {
        this.to.tabHidden = !!value;
    }
}
FormlyWrapperTabComponent.ɵfac = /*@__PURE__*/ function () { let ɵFormlyWrapperTabComponent_BaseFactory; return function FormlyWrapperTabComponent_Factory(t) { return (ɵFormlyWrapperTabComponent_BaseFactory || (ɵFormlyWrapperTabComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(FormlyWrapperTabComponent)))(t || FormlyWrapperTabComponent); }; }();
FormlyWrapperTabComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormlyWrapperTabComponent, selectors: [["formly-wrapper-tab"]], viewQuery: function FormlyWrapperTabComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 5, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fieldComponent = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [[3, "title", "disabled", "hidden"], ["fieldComponent", ""]], template: function FormlyWrapperTabComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "formly-tabs-tab", 0);
        ɵngcc0.ɵɵtemplate(1, FormlyWrapperTabComponent_ng_template_1_Template, 0, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("title", ctx.title)("disabled", ctx.disabled)("hidden", ctx.hidden);
    } }, directives: [TabComponent], encapsulation: 2 });
FormlyWrapperTabComponent.propDecorators = {
    fieldComponent: [{ type: ViewChild, args: ['fieldComponent', { read: ViewContainerRef },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyWrapperTabComponent, [{
        type: Component,
        args: [{
                selector: 'formly-wrapper-tab',
                template: `
        <formly-tabs-tab [title]="title" [disabled]="disabled" [hidden]="hidden">
            <ng-template #fieldComponent>
            </ng-template>
        </formly-tabs-tab>
    `
            }]
    }], null, { fieldComponent: [{
            type: ViewChild,
            args: ['fieldComponent', { read: ViewContainerRef }]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VisiblePipe {
    /**
     * @param {?} tabs
     * @return {?}
     */
    transform(tabs) {
        return Array.isArray(tabs) ? tabs.filter((/**
         * @param {?} t
         * @return {?}
         */
        t => !t.hidden)) : [];
    }
}
VisiblePipe.ɵfac = function VisiblePipe_Factory(t) { return new (t || VisiblePipe)(); };
VisiblePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "visible", type: VisiblePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VisiblePipe, [{
        type: Pipe,
        args: [{ name: 'visible' }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const FIELD_TYPE_COMPONENTS = [
    // types
    FormlyFieldTabComponent,
    FormlyFieldTabsetComponent,
    // wrappers
    FormlyWrapperTabComponent
];
/** @type {?} */
const FORMLY_TABS_FORMLY_CONFIG = {
    types: [
        { name: 'tab', component: FormlyFieldTabComponent },
        { name: 'tabset', component: FormlyFieldTabsetComponent }
    ],
    wrappers: [
        { name: 'tab', component: FormlyWrapperTabComponent }
    ]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormlyTabsModule {
}
FormlyTabsModule.ɵfac = function FormlyTabsModule_Factory(t) { return new (t || FormlyTabsModule)(); };
FormlyTabsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FormlyTabsModule });
FormlyTabsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ReactiveFormsModule,
            FormlyModule.forRoot(FORMLY_TABS_FORMLY_CONFIG),
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyTabsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    FormlyModule.forRoot(FORMLY_TABS_FORMLY_CONFIG),
                ],
                declarations: [
                    TabsetComponent,
                    TabComponent,
                    FIELD_TYPE_COMPONENTS,
                    VisiblePipe,
                ],
                exports: [
                    TabsetComponent,
                    TabComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormlyTabsModule, { declarations: function () { return [TabsetComponent, TabComponent, FormlyFieldTabComponent, FormlyFieldTabsetComponent, FormlyWrapperTabComponent, VisiblePipe]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule, ɵngcc2.FormlyModule]; }, exports: function () { return [TabsetComponent, TabComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { TabsetService, TabsetComponent, TabComponent, FormlyFieldTabComponent, FormlyFieldTabsetComponent, FormlyWrapperTabComponent, FormlyTabsModule, FIELD_TYPE_COMPONENTS as ɵa, FORMLY_TABS_FORMLY_CONFIG as ɵb, VisiblePipe as ɵc };

